import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { push } from 'connected-react-router';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { usePlatofrmType } from '~hooks';
import { PLATFORMS } from '~slices/teasers';
import { useAppDispatch } from '~store';
import { logout, refresh } from '~slices/auth';
import { acceptTerms, resetTermsState } from '~slices/terms';
import { BottomButtons } from '~atoms/bottomButton';
import { getPathWithLanguageCode } from '~utils/languageInURL/getPathWithLanguageCode';
var useStyles = makeStyles(function (theme) {
    var _a, _b;
    return ({
        termsBlock: (_a = {},
            _a[theme.breakpoints.up('lg')] = {
                marginLeft: '-20px',
                width: 'calc(100% + 42px)',
                position: 'sticky',
            },
            _a),
        button: (_b = {
                minWidth: '120px',
                width: '100%'
            },
            _b[theme.breakpoints.up('lg')] = {
                minWidth: '160px',
            },
            _b),
    });
}, { name: 'TermsButtons' });
export var TermsButtons = function () {
    var classes = useStyles();
    var t = useTranslation([
        'common',
        'header',
    ]).t;
    var dispatch = useAppDispatch();
    var platform = usePlatofrmType();
    var notAcceptButtonText = platform === PLATFORMS.CROSS_PLATFORM_MOBILE
        ? t('common:buttons.back')
        : t('header:logout');
    var onAccept = function () {
        dispatch(acceptTerms()).then(function () { return dispatch(refresh()); });
    };
    var onLogout = function () {
        dispatch(logout());
        dispatch(resetTermsState());
        dispatch(push(getPathWithLanguageCode('/home')));
    };
    return (React.createElement(BottomButtons, { className: classes.termsBlock },
        React.createElement(Grid, { container: true, justify: "space-between", spacing: 2 },
            React.createElement(Grid, { key: "cancel", item: true },
                React.createElement(Button, { variant: "contained", classes: { root: classes.button }, onClick: onLogout }, notAcceptButtonText)),
            React.createElement(Grid, { key: "next", item: true },
                React.createElement(Button, { variant: "contained", classes: { root: classes.button }, color: "primary", onClick: onAccept }, t('header:accept'))))));
};
